const DogecoinCnt = {
  symbol: "DOGE",
  name: "dogecoin",
  meta: {
    title: "Buy Dogecoin | Dogecoin Sale Dogecoin prices and charts",
    description:
      "Dogecoin (DOGE) Ilan Musk's popular currency is the richest man on earth, and coinnik Market has made it possible to buy and sell Dogecoin directly and without intermediaries.",
    keywords: "Dogecoin, Buy dogecoin, Sell dogecoin, dogecoin Price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه دوج کوین بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید دوج کوین کنید. قیمت دوج کوین در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول دوج کوین کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "کیف پول‌هایی که سایت دوج کوین برای نگهداری این ارز دیجیتال معرفی کرده است این کیف پول‌ها هستند:  کیف پول دسکتاپ MultiDoge، کیف پول موبایل Dogecoin Wallet (اندروید) و Dough Wallet (iOS) و کیف پول سخت افزاری Ledger و Trezor",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توانم دوج کوین نگهداری کنم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دوج کوین دارید دارید، که می‌توانید دوج کوین را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت..",
        },
      },
      {
        "@type": "Question",
        name: "آیا دوج کوین ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "ارزش بازار دوج کوین، در حال حاضر بیش از ۷ میلیارد دلار است و حجم معامله روزانه این ارز دیجیتال از ترافیک بالایی برخوردار است. از طرفی دوج کوین حامیان مطرحی مثل ایلان ماسک دارد که روی افزایش قیمت آن بسیار تاثیرگذار است. اگر نگاهی به تاریخچه قیمتی دوج کوین بیاندازیم می‌بینیم که تا به حال صعودهای قابل توجهی را تجربه کرده است. برخی سایت‌های مرجع پیش بینی کرده‌اند تا ۱۰ سال آینده قیمت دوج کوین به ۱۰ دلار خواهد رسید.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Dogecoin",
      answer:
        "In coinnik Market trading platform, you can buy Dodge Quinn with Shetab member bank card and the lowest fee. The price of Dodge Quinn in coinnik Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best Dogecoin wallet?",
      answer: "Dogecoin_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a Dogecoin at coinnik Market?",
      answer: "Keep_Dogecoin_description",
      id: "toggler3",
    },
    {
      question: "Is Dogecoin worth the investment?",
      answer: "Dogecoin_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Dogecoin",
        subTitle: "What is Dogecoin",
        content: "Dogecoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Dogecoin",
        content: "Dogecoin_history_description",
        btnTitle: "Buy and sell Dogecoin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Dogecoin without intermediaries in coinnik Market",
        subTitle: "Buy Dogecoin",
        content: "Buy_Dogecoin_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Dogecoin",
        content: "Sell_Dogecoin_description",
        btnTitle: "Buy and sell Dogecoin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest dogecoin analysis on the blog",
  informationTitle: "dogecoin market statistics and information",
};

export default DogecoinCnt;
